export enum OnlineContractingStateEnum {
  ContractingStarted = 'CONTRATACAO_INICIADA',
  ContractingDenied = 'CONTRATACAO_NEGADA',
  ProcessingCreditAnalysis = 'PROCESSANDO_ANALISE_CREDITO',
  CreditAnalysisRejected = 'ANALISE_CREDITO_REPROVADA',
  WaitingProposalGeneration = 'AGUARDANDO_GERACAO_PROPOSTA',
  WaitingSelfie = 'AGUARDANDO_SELFIE',
  CpfBlocked = 'CPF_BLOQUEADO',
  WaitingProposalAcceptance = 'AGUARDANDO_ACEITE_PROPOSTA',
  WaitingDownPayment = 'AGUARDANDO_PAGAMENTO_ENTRADA',
  WaitingBilling = 'AGUARDANDO_FATURAMENTO',
  ProcessingBilling = 'PROCESSANDO_FATURAMENTO',
  ProcessingCancellation = 'PROCESSANDO_CANCELAMENTO',
  ContractingFinished = 'CONTRATACAO_FINALIZADA',
  ExpiredKey = 'CHAVE_EXPIRADA',
}

export enum ContractingStatusColorEnum {
  undefined = 'warning',
  ContractingFinished = 'info',
  CreditAnalysisRejected = 'blue',
  CafRejected = 'green',
  CpfBlocked = 'tertiary',
  ContractingDenied = 'error',
}
